import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import FleetSidebar from "../FleetSidebar/FleetSidebar";

const FleetLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<FleetSidebar />}>{children}</NavigationBar>
);

export default FleetLayout;
